
import { Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Index from "./pages/Index";
import LandingPage from "./pages/LandingPage";
import Product from "./pages/Product";
import ProductGroup from "./pages/ProductGroup";
import AVOIPOptions from "./pages/AVOIPOptions";
import ReAXOptions from "./pages/ReAXOptions";
import AudioOptions from "./pages/AudioOptions";
import FeaturesAndBenefits1Gb from "./pages/FeaturesAndBenefits1Gb";
import FeaturesAndBenefitsRXT4D from "./pages/FeaturesAndBenefitsRXT4D";
import FeaturesAndBenefitsAudio from "./pages/FeaturesAndBenefitsAudio";
import FeaturesAndBenefitsDIDO from "./pages/FeaturesAndBenefitsDIDO";
import RequestPricing from "./pages/RequestPricing";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import SecretPricing from "./pages/SecretPricing";
import AccessCheck from "./components/AccessCheck";
import FeaturesAndBenefitsReAX from "./pages/FeaturesAndBenefitsReAX";
import WhereToBuy from "./pages/WhereToBuy";
import AccountDeletion from "./pages/AccountDeletion";

function App() {
  return (
    <LanguageProvider>
      <Routes>
        {/* Public routes that don't require authentication */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-and-privacy" element={<Privacy />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        
        {/* Landing page (entry point) */}
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/" element={<LandingPage />} />
        
        {/* Admin pricing (special case) */}
        <Route path="/admin-pricing" element={<SecretPricing />} />
        
        {/* Protected routes that require access check */}
        <Route element={<AccessCheck />}>
          <Route path="/home" element={<Index />} />
          <Route path="/avoip-options" element={<AVOIPOptions />} />
          <Route path="/reax-options" element={<ReAXOptions />} />
          <Route path="/audio-options" element={<AudioOptions />} />
          <Route path="/features-benefits-1gb" element={<FeaturesAndBenefits1Gb />} />
          <Route path="/features-benefits-rxt4d" element={<FeaturesAndBenefitsRXT4D />} />
          <Route path="/features-benefits-reax" element={<FeaturesAndBenefitsReAX />} />
          <Route path="/features-benefits-audio" element={<FeaturesAndBenefitsAudio />} />
          <Route path="/features-benefits-dido" element={<FeaturesAndBenefitsDIDO />} />
          <Route path="/request-pricing" element={<RequestPricing />} />
          <Route path="/where-to-buy" element={<WhereToBuy />} />
          <Route path="/group/:slug" element={<ProductGroup />} />
          <Route path="/product/:slug" element={<Product />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </LanguageProvider>
  );
}

export default App;
